import api from './api';

export interface AdminStats {
  total_users: number;
  total_banks: number;
  total_cards: number;
  total_offers: number;
  active_offers: number;
  total_merchants: number;
  users_by_type: { [key: string]: number };
  offers_by_bank: Array<{ bank__name: string; count: number }>;
}

export interface Bank {
  id: number;
  name: string;
  code: string;
  cards_count: number;
  offers_count: number;
  is_active: boolean;
  created_at: string;
}

export interface AdminCard {
  id: number;
  name: string;
  bank: string;
  card_type: string;
  annual_fee: number;
  is_active: boolean;
  last_scraped: string | null;
  users_count: number;
}

export interface Offer {
  id: number;
  title: string;
  bank: string;
  merchant: string | null;
  offer_type: string;
  discount_percentage: number | null;
  valid_to: string;
  is_active: boolean;
  last_updated: string;
}

export interface ScrapeResult {
  status: 'success' | 'error';
  created?: number;
  updated?: number;
  total?: number;
  bank?: string;
  error?: string;
}

export interface TTBankWithCards {
  id: number;
  name: string;
  code: string;
  country: string;
  bank_type: string;
  operating_category?: 'TRADITIONAL' | 'NON_TRADITIONAL' | 'UNKNOWN';
  is_traditional_bank?: boolean;
  website: string;
  logo_url?: string | null;
  support_email: string;
  support_phone: string;
  headquarters?: string | null;
  established_year?: number | null;
  total_branches?: number | null;
  digital_banking: boolean;
  mobile_app: boolean;
  atm_network?: string | null;
  is_active: boolean;
  created_at: string;
  total_cards: number;
  active_cards: number;
  cards: Array<{
    id: number;
    name: string;
    card_type: string;
    annual_fee: number;
    interest_rate?: number | null;
    credit_limit_min?: number | null;
    credit_limit_max?: number | null;
    reward_points_rate: number;
    cashback_rate: number;
    reward_currency_basis: string;
    welcome_bonus?: string | null;
    requirements?: string | null;
    features?: string | null;
    image_url?: string | null;
    scraping_url?: string | null;
    last_scraped?: string | null;
    is_active: boolean;
    created_at: string;
    bank: {
      id: number;
      name: string;
      code: string;
    };
  }>;
}

export interface ScrapingLog {
  id: number;
  bank: {
    id: number;
    name: string;
    code: string;
  } | null;
  task_id: string | null;
  status: 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED';
  offers_found: number;
  offers_created: number;
  offers_updated: number;
  error_message: string | null;
  started_at: string;
  completed_at: string | null;
  duration_seconds: number | null;
  scraped_data: any; // JSON data
}

export const adminService = {
  getDashboardStats: async (): Promise<AdminStats> => {
    const response = await api.get('/admin-panel/dashboard/');
    return response.data;
  },
  getBanks: async (): Promise<Bank[]> => {
    const response = await api.get('/admin-panel/banks/');
    return response.data;
  },
  getCards: async (): Promise<AdminCard[]> => {
    const response = await api.get('/admin-panel/cards/');
    return response.data;
  },
  getOffers: async (): Promise<Offer[]> => {
    const response = await api.get('/admin-panel/offers/');
    return response.data;
  },
  scrapeTrinidadTobagoBank: async (bankCode: string): Promise<ScrapeResult> => {
    const response = await api.post('/scraping/scrape-trinidad-tobago-bank/', {
      bank_code: bankCode,
    });
    return response.data;
  },
  
  getTTBanksWithCards: async (): Promise<TTBankWithCards[]> => {
    const response = await api.get('/admin-panel/tt-banks/');
    return response.data;
  },
  getScrapingLogs: async (): Promise<{ logs: ScrapingLog[] }> => {
    const response = await api.get('/admin-panel/scraping-logs/');
    return response.data;
  },
};
